<template>
    <ui-modal class="activity-modal" ref="modal" :title="title" dismiss-on="close-button esc" @hide="reset" size="large">
        <activity-pane 
            ref="activityPane" 
            :show-hidden-fields-by-default="true"
            @saving="isSaving = true" 
            @saved="activitySaved" 
            @error="isSaving = false"
        />

        <p v-if="activity && activity.created_by" style="margin-bottom: 0; color: #999;">
            Created by {{ activity.created_by.name }}, {{ activity.created_at | formatDate }}.
        </p>

        <div slot="footer" class="container-fluid no-left-padding no-right-padding">
            <div class="row align-items-center">
                <div class="col text-left">
                    <ui-icon-button 
                        ref="dropdownButton"
                        has-dropdown 
                        icon="more_vert"
                        :disabled="!activity || isSaving"
                    >
                        <ui-menu
                            contain-focus
                            has-icons
                            slot="dropdown"
                            :options="menuOptions"
                            @select="menuItemSelected"
                            @close="$refs.dropdownButton.closeDropdown()"
                        ></ui-menu>
                    </ui-icon-button>
                </div>
                <div class="col text-right">
                    <div style="display: inline-block; vertical-align: middle;">
                        <ui-switch 
                            style="margin: 0; padding: 0;"
                            v-model="isDone"
                        >Mark as done</ui-switch>
                    </div>
                    <div style="display: inline-block;" class="ml-3">
                        <ui-button 
                            @click="$refs.activityPane.save()" 
                            :loading="isSaving" 
                            color="primary"
                        >Save</ui-button>
                    </div>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<style lang="scss">
    .activity-modal.ui-modal--size-normal > .ui-modal__wrapper > .ui-modal__container { width: 38rem; }
</style>

<script>
    import ActivityPane from './forms/ActivityPane'
    import {ActivityMediums, ActivityResource} from '../classes/Api/Activity'
    import Filters from '../filters'
    import Moment from "moment-timezone";
    import deleteActivity from "./activity/ActivityDeletionLogic";

    const menuOptions = [
        {
            label: 'Delete',
            icon: 'delete'
        },
    ];

    export default {
        filters: Filters,
        components: {
            ActivityPane
        },
        data() {
            return {
                activity: null,
                isSaving: false,
                isDone: false,
            }
        },
        computed: {
            title() {
                return this.activity && this.activity.id ? 'Update Diary Activity' : 'New Diary Activity'
            },
            menuOptions() {
                return menuOptions
            },
        },
        methods: {
            open(activity = null) {
                if (activity && typeof activity === 'object') {
                    this.activity = activity

                    if (activity.completed_at) {
                        this.isDone = true
                    }

                    this.$refs.activityPane.setActivity(activity)

                    this.$refs.modal.open();
                } else if (typeof activity === 'number' || typeof activity === 'string' ) {
                    this.$refs.activityPane.loadActivity(activity).then(loadedActivity => {
                        if (loadedActivity.completed_at) {
                            this.isDone = true
                        }

                        this.activity = loadedActivity

                        this.$refs.modal.open();
                    })
                } else {
                    this.$refs.modal.open();
                }
            },
            reset() {
                this.$refs.activityPane.reset()
                this.activity = null
                this.isSaving = false
                this.isDone = false
            },
            close() {
                this.$refs.modal.close();
                this.reset()
                this.$emit('closing')
            },
            activitySaved(activity) {
                let promise;

                if (this.isDone && !activity.completed_at) {
                    promise = ActivityResource.complete(activity.id)
                } else if (!this.isDone && activity.completed_at) {
                    promise = ActivityResource.uncomplete(activity.id);
                }

                Promise.all([promise]).then(r => {
                    this.isSaving = false;

                    let savedActivity = Object.assign(activity)
                    let isDone = this.isDone

                    this.$emit('saved', activity);

                    this.close()

                    setTimeout(() => {
                        if (isDone && confirm('Do you want to create a follow up activity?')) {
                            this.open({
                                contact_id: savedActivity.contact_id,
                                contact: savedActivity.contact,
                                lead_id: savedActivity.lead_id,
                                lead: savedActivity.lead,
                                owner_id: savedActivity.owner_id,
                                owner: savedActivity.owner,
                                medium: ActivityMediums.CALL,
                                instance_id: savedActivity.instance_id,
                                due_at: Moment().add(1, 'hour').minutes(0).seconds(0).toDate(),
                            })
                        }
                    }, 500)
                }).catch(e => {
                    handleApiError(e)
                    this.isSaving = false
                })
            },
            menuItemSelected(item) {
                if (item.icon === 'delete' && confirm('Are you sure you want to delete this activity?')) {
                    this.isSaving = true

                    deleteActivity(this.activity).then(() => {
                        this.$emit('deleted', this.activity)
                        this.close()
                    }).finally(() => {
                        this.isSaving = false
                    })
                }
            }
        }
    }
</script>